export const formatDate = rawDate => {
  try {
    return new Date(rawDate)
      .toLocaleDateString("en-US", {
        month: "long",
        day: "2-digit",
        year: "numeric",
      })
      .replace(",", " -")
  } catch (err) {
    console.log(err)
  }
}
